import { GITHUB_ZIP_API } from "constants/url";

// * Assumption - Used github link would be one of these format
// * - https://github.com/owner/repo, https://github.com/owner/repo/, https://github.com/owner/repo.git
const githubRegex = /github\.com\/([^/]+)\/([^/.]+)/;

export function getGithubUserAndRepo(url: string) {
  const match = url.match(githubRegex);

  if (!match) return { user: "", repo: "" };

  const [, user, repo] = match;

  return { user, repo };
}

export function isGithubLink(url: string) {
  const isGithubLink = githubRegex.test(url);

  return isGithubLink;
}

// * generated zip api url will redirect to download link.
export function getGithubZipballLink(url: string, branch: string) {
  const branchName = branch ? branch : "";

  if (!isGithubLink(url)) return url;
  const { user, repo } = getGithubUserAndRepo(url);

  const githubZipURL = GITHUB_ZIP_API.replace(":user", user)
    .replace(":repo", repo)
    .replace(":branch_name", branchName);

  return githubZipURL;
}
